import { render, staticRenderFns } from "./FloatButton.vue?vue&type=template&id=a059b3f4"
import script from "./FloatButton.vue?vue&type=script&lang=ts"
export * from "./FloatButton.vue?vue&type=script&lang=ts"
import style0 from "./FloatButton.vue?vue&type=style&index=0&id=a059b3f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports